// Timer will be set relative to 'startTime', if provided. Can be used to ensure dialogs/loaders don't quickly flash without unnecessarily slowing down the app.
module.exports = function(duration = 0, startTime = null) {
    if (startTime) duration = Math.max(0, duration + startTime - Date.now());
    return new Promise(res => setTimeout(res, duration));
};